import IconButton from "@mui/material/IconButton";
import { Save } from "@mui/icons-material";

const IconButtonSave = ({ onBtnClick, disabled, size = "medium" }) => {
  const handleAction = () => {
    onBtnClick();
  };

  return (
    <IconButton onClick={() => handleAction()} disabled={disabled} size={size}>
      <Save fontSize="inherit" />
    </IconButton>
  );
};

export default IconButtonSave;
